export default "__VITE_ASSET__DF3ruSM1__"